import React, { Component } from "react";
import { Polygon, InfoWindow } from "@vis.gl/react-google-maps";
import { connect } from "react-redux";
import { mapSelectedPolygon, mapChangePolygon } from "../../reducers/map";

class Impolygon extends Component {
  onPathsChanged = (paths) => {
    try {
      const ring = (paths && paths[0]) ? paths[0].map((p) => ({ lat: p.lat(), lng: p.lng() })) : [];
      this.props.POLYGON_CHANGE({ ...this.props, path: ring });
    } catch (e) {}
  };

  selectInfo = () => this.props.POLYGON_SELECTING(this.props.id);

  render() {
    const id = this.props.id;
    const selected = this.props.polygon_selecting === id;
    const center = this.props.path && this.props.path[0];
    return (
      <React.Fragment>
        <Polygon
          paths={this.props.path}
          editable={this.props.editable}
          draggable={this.props.editable}
          strokeColor="blue"
          onClick={this.selectInfo}
          onPathsChanged={this.onPathsChanged}
        />
        {selected && center ? (
          <InfoWindow position={center}>
            <div>
              {this.props.info.logisticsPoint ? "Logistic Point : " + this.props.info.logisticsPoint : ""}
              <br />Name: <br />{this.props.info.name}
              Description: <br />{this.props.info.description}
              <br />{this.props.isGroup}
            </div>
          </InfoWindow>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({ polygon_selecting: state.map.polygon_selecting });
const mapActionsToProps = { POLYGON_SELECTING: mapSelectedPolygon, POLYGON_CHANGE: mapChangePolygon };
export default connect(mapStateToProps, mapActionsToProps)(Impolygon);
